module.exports = __webpack_public_path__ + "static/img/logomini2.6804b415.png";